<template>
  <div>
    <div class="bg-app"></div>
    <Header />

    <div class="app-container">
      <div class="fixed inset-0 bg-opacity-50 bg-base-100 text-base-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  components: { Header },
  mounted() {
    const currentModule = localStorage.getItem("currentModule");

    if (currentModule) {
      this.$store.commit("setCurrentModule", JSON.parse(currentModule));
    }
  }
};
</script>

<style lang="scss" src="@/assets/scss/main.scss" />
